"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import Image from "next/image";
import MaxWidthWrapper from "@/components/shared/max-width-wrapper";

export default function PreviewLanding() {

  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="pb-6 sm:pb-16">
      <MaxWidthWrapper>
        <div className="rounded-xl md:bg-muted/30 md:p-3.5 md:ring-1 md:ring-inset md:ring-border">
          <div className="relative aspect-video overflow-hidden rounded-xl border md:rounded-lg">
            {mounted && (
              <Image
                className="size-full object-cover object-center dark:opacity-85"
                src={`/_static/illustrations/dashboard-${resolvedTheme}.png`}
                alt="Watchero"
                width={2992}
                height={1692}
                priority={true}
              />
            )}
          </div>
        </div>
      </MaxWidthWrapper>
    </div>
  );
}
